import Vue from 'vue';

const { $gettext } = Vue.prototype;

export const CustomerFilters = () => {
  const { getters } = Vue.prototype.store;

  return [
    {
      label: $gettext('Url'),
      field: 'url',
      type: 'input',
      value: null,
    },
  ];
};

export default {
  headers: [
    { text: $gettext('From'), value: 'createdDate' },
    { text: $gettext('Company'), value: 'name' },
    { text: $gettext('Location'), value: 'locationCount' },
    { text: $gettext('Staff'), value: 'staffCount' },
    { text: $gettext('Contact'), value: 'contactPerson' },
    { text: $gettext('Email'), value: 'email' },
    { text: $gettext('Phone'), value: 'phone' },
    { text: $gettext('Country'), value: 'country' },
    { text: $gettext('Url'), value: 'url' },
    { text: $gettext('Admin'), value: 'adminAccount' },
    { text: $gettext(' '), sortable: false },
  ],
};
